import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Typography,
  TextField,
  IconButton,
  List,
} from "@material-ui/core";

import SendIcon from "@material-ui/icons/Send";

import SpinnerSmall from "../../../layout/SpinnerSmall";
import DisputeContext from "../../../../context/paypal/disputes/DisputeContext";

const FunctionSendMessage = ({
  state,
  setState,
  setReturnedMsg,
  disputeMessages,
  linkSendMessage,
}) => {
  // Initiate Local State
  const disputeContext = useContext(DisputeContext);
  const { loading, dispute, sendDisputeMessage } = disputeContext;
  const [filteredMessage, setFilteredMessage] = useState();

  const useStyles = makeStyles((theme) => ({
    paperBuyer: {
      padding: theme.spacing(1),
      textAlign: "justifyContent",
      color: theme.palette.text.primary,
    },
    paperSeller: {
      padding: theme.spacing(1),
      textAlign: "justifyContent",
      color: theme.palette.text.primary,
      backgroundColor: "#f1f0f4",
    },
    messageGrid: {
      padding: theme.spacing(1),
    },
    cardFooterMessage: {
      backgroundColor: "#FFFFFF",
      height: 210,
    },
    list: {
      width: "100%",
      backgroundColor: "#FDFDFD",
      position: "relative",
      overflow: "auto",
      height: 320,
    },
    buttonSend: {
      "&:focus": {
        outline: "none",
      },
    },
    emailTextField: {
      fontSize: 12,
    },
    errorText: {
      color: "#ff3333",
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    if (disputeMessages) {
      const messageArray = [];
      for (let x in disputeMessages) {
        const contentArray = [];
        // Filter Message with line break
        const match = /\r|\n/.exec(disputeMessages[x].content);
        if (match) {
          const str = match.input.split(/(?:\r\n|\r|\n)/g);
          for (let y in str) {
            contentArray.push(str[y]);
          }
        } else {
          contentArray.push(disputeMessages[x].content);
        }
        messageArray.push({
          posted_by: disputeMessages[x].posted_by,
          time_posted: new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
            timeZone: "Asia/Kuala_Lumpur",
          }).format(new Date(disputeMessages[x].time_posted)),
          content: contentArray,
        });
      }
      setFilteredMessage(messageArray);
    }
  }, [disputeMessages]);

  //Filter Message Input (1 - 2000 characters)
  const onMessageChange = (e) => {
    e.preventDefault();
    e.persist();
    const value = e.target.value;
    let errors = state.errors;
    if (e.target.id === "message_value") {
      setState((state) => ({
        ...state,
        [e.target.id]: value,
        errors: errors,
      }));
    }
  };

  const onMessageSend = () => {
    const value = state.message_value;
    let errors = "";
    if (value.length > 2000) {
      errors = "Maximum 2000 characters.";
    } else if (value.trim() === "") {
      errors = "Can't be blank.";
    } else if (value.length > 0 && value.length <= 2000) {
      errors = "";
      setReturnedMsg("");
      sendDisputeMessage(state.message_value, dispute.dispute_id);
    }

    if (errors !== state.errors.message_value) {
      setState((state) => ({
        ...state,
        errors: {
          message_value: errors,
        },
      }));
      setTimeout(() => {
        setState((state) => ({
          ...state,
          errors: {
            message_value: "",
          },
        }));
      }, 5000);
    }
  };

  const ListContainer = () => {
    let listContainer = useRef();

    const scrollToBottom = () => {
      listContainer.scrollTop = listContainer.scrollHeight;
    };

    useEffect(() => {
      scrollToBottom();
    });

    return (
      <List
        className={classes.list}
        ref={(element) => {
          listContainer = element;
        }}
      >
        {filteredMessage ? (
          <Fragment>
            {" "}
            {filteredMessage.map((each, index) => {
              if (each.posted_by && each.posted_by === "BUYER") {
                return (
                  <Grid item xs={9}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      className={classes.messageGrid}
                    >
                      <Grid item xs={12}>
                        <Typography variant="inherit"> Buyer </Typography> &
                        ensp;{" "}
                        <Typography variant="overline">
                          {" "}
                          {each.time_posted}{" "}
                        </Typography>{" "}
                      </Grid>{" "}
                      <Grid item>
                        <Paper className={classes.paperBuyer}>
                          <Grid container direction="column">
                            {" "}
                            {each.content.map((each1) => {
                              return (
                                <Grid
                                  item
                                  style={{
                                    minHeight: 20,
                                  }}
                                  xs={12}
                                >
                                  <Typography
                                    variant="caption"
                                    display="block"
                                    style={{
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {each1}{" "}
                                  </Typography>{" "}
                                </Grid>
                              );
                            })}{" "}
                          </Grid>{" "}
                        </Paper>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>
                );
              } else if (each.posted_by && each.posted_by === "SELLER") {
                return (
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-end"
                      className={classes.messageGrid}
                    >
                      <Grid item xs={12}>
                        <Grid container direction="row" justifyContent="flex-end">
                          <Typography variant="overline">
                            {" "}
                            {each.time_posted}{" "}
                          </Typography>{" "}
                          & ensp;{" "}
                          <Typography variant="inherit"> Seller </Typography>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                      <Grid item xs={9}>
                        <Grid container direction="row" justifyContent="flex-end">
                          <Paper className={classes.paperSeller}>
                            <Grid container direction="column">
                              {" "}
                              {each.content.map((each1) => {
                                return (
                                  <Grid
                                    item
                                    style={{
                                      minHeight: 20,
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      display="block"
                                      style={{
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {each1}{" "}
                                    </Typography>{" "}
                                  </Grid>
                                );
                              })}{" "}
                            </Grid>{" "}
                          </Paper>{" "}
                          & ensp;{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>
                );
              }
            })}{" "}
          </Fragment>
        ) : null}{" "}
        {loading ? (
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              className={classes.messageGrid}
            >
              <Grid item xs={9}>
                <Grid container direction="row" justifyContent="flex-end">
                  <Paper className={classes.paperSeller}>
                    <Typography variant="caption">
                      <div className="d-flex mx-auto my-auto">
                        <SpinnerSmall />
                      </div>{" "}
                      Sending Message...
                    </Typography>{" "}
                  </Paper>{" "}
                  & ensp;{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>
        ) : null}{" "}
      </List>
    );
  };

  return (
    <Fragment>
      <ListContainer />
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        className={classes.cardFooterMessage}
      >
        <Grid item xs={11}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <TextField
              type="text"
              variant="outlined"
              id="message_value"
              name="message_value"
              size="small"
              fullWidth
              placeholder="Type a message..."
              multiline
              rows={10}
              maxRows={10}
              value={state.message_value}
              disabled={loading || linkSendMessage}
              onInput={onMessageChange}
            />{" "}
          </Grid>{" "}
        </Grid>{" "}
        <Grid
          item
          xs={1}
          style={{
            height: 210,
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-end"
            style={{
              height: "70%",
            }}
          >
            <IconButton
              aria-label="expand row"
              onClick={onMessageSend}
              className={classes.buttonSend}
              disabled={loading || linkSendMessage}
            >
              <SendIcon
                style={
                  loading || linkSendMessage
                    ? {
                        color: "#cccccc",
                      }
                    : {
                        color: "#2f2c3a",
                      }
                }
              />{" "}
            </IconButton>{" "}
          </Grid>{" "}
          <Grid
            container
            direction="row"
            alignItems="flex-end"
            style={{
              height: "30%",
            }}
          >
            <Grid item xs={1}>
              {" "}
            </Grid>{" "}
            <Grid item>
              {" "}
              {2000 - state.message_value.length < 0 ? (
                <Typography variant="caption" className={classes.errorText}>
                  {" "}
                  {2000 - state.message_value.length}{" "}
                </Typography>
              ) : (
                <Typography variant="caption">
                  {" "}
                  {2000 - state.message_value.length}{" "}
                </Typography>
              )}{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Fragment>
  );
};

export default FunctionSendMessage;
